import { render, staticRenderFns } from "./AdminVessels.vue?vue&type=template&id=0182005c&scoped=true"
import script from "./AdminVessels.vue?vue&type=script&lang=js"
export * from "./AdminVessels.vue?vue&type=script&lang=js"
import style0 from "./AdminVessels.vue?vue&type=style&index=0&id=0182005c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0182005c",
  null
  
)

export default component.exports